var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.shouldCollapse
    ? _c(
        "div",
        {
          staticClass: "action-menu",
        },
        [
          _c(
            "button",
            {
              staticClass: "action-menu-icon",
              attrs: {
                title: _vm.title,
                "aria-expanded": "false",
              },
            },
            [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "action-menu-content",
            },
            [
              _c(
                "div",
                {
                  staticClass: "action-menu-title",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$gettext("Aktionen")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "action-menu-list",
                },
                _vm._l(_vm.navigationItems, function (item) {
                  var _item$attributes, _item$attributes2

                  return _c(
                    "li",
                    {
                      key: item.id,
                      staticClass: "action-menu-item",
                    },
                    [
                      item.type === "link"
                        ? _c(
                            "a",
                            _vm._g(
                              _vm._b({}, "a", _vm.linkAttributes(item), false),
                              _vm.linkEvents(item)
                            ),
                            [
                              item.icon !== false
                                ? _c("studip-icon", {
                                    attrs: {
                                      shape: item.icon.shape,
                                      role: item.icon.role,
                                    },
                                  })
                                : _c("span", {
                                    staticClass: "action-menu-no-icon",
                                  }),
                              _vm._v(
                                "\n\n                    " +
                                  _vm._s(item.label) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        : item.icon
                        ? _c(
                            "label",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "undecorated",
                                },
                                "label",
                                _vm.linkAttributes(item),
                                false
                              ),
                              _vm.linkEvents(item)
                            ),
                            [
                              _c(
                                "studip-icon",
                                _vm._b(
                                  {
                                    attrs: {
                                      shape: item.icon.shape,
                                      role: item.icon.role,
                                      name: item.name,
                                      title: item.label,
                                    },
                                  },
                                  "studip-icon",
                                  (_item$attributes = item.attributes) !==
                                    null && _item$attributes !== void 0
                                    ? _item$attributes
                                    : {},
                                  false
                                )
                              ),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.label) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        : [
                            _c("span", {
                              staticClass: "action-menu-no-icon",
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      name: item.name,
                                    },
                                  },
                                  "button",
                                  Object.assign(
                                    (_item$attributes2 = item.attributes) !==
                                      null && _item$attributes2 !== void 0
                                      ? _item$attributes2
                                      : {},
                                    _vm.linkAttributes(item)
                                  ),
                                  false
                                ),
                                _vm.linkEvents(item)
                              ),
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(item.label) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          ),
        ]
      )
    : _c(
        "div",
        _vm._l(_vm.navigationItems, function (item) {
          return _c(
            "a",
            _vm._g(
              _vm._b(
                {
                  key: item.id,
                },
                "a",
                _vm.linkAttributes(item),
                false
              ),
              _vm.linkEvents(item)
            ),
            [
              _c("studip-icon", {
                attrs: {
                  title: item.label,
                  shape: item.icon.shape,
                  role: item.icon.role,
                  size: 20,
                },
              }),
            ],
            1
          )
        }),
        0
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }